module.exports = __webpack_public_path__ + "media/fonts/garamond/AGaramondPro-Regular-6d814e00e5a17858709650e5c7752f66.woff2";